import type { Id } from '../../../convex/_generated/dataModel'

type PrescriptionProfile = {
    _id: Id<'profiles'>
    ruolo: string
    company_id?: Id<'companies'>
}

/** Il catalogo segue società della prescrizione e medico, anche per chi opera per suo conto. */
export function prescriptionServiceQueryArgs(
    profile: PrescriptionProfile | null | undefined,
    selectedCompanyId: string,
    selectedDoctorId: string,
): { company_id: Id<'companies'>; profile_id?: Id<'profiles'> } | 'skip' {
    if (!profile) return 'skip'

    const isLabOperator = profile.ruolo === 'amministratore' || profile.ruolo === 'tecnico_lab'
    const companyId = isLabOperator ? selectedCompanyId : profile.company_id
    if (!companyId) return 'skip'

    const doctorId = profile.ruolo === 'dentista' ? profile._id : selectedDoctorId
    return {
        company_id: companyId as Id<'companies'>,
        ...(doctorId ? { profile_id: doctorId as Id<'profiles'> } : {}),
    }
}
